import {AgreementService as Service} from './AgreementService';
import {Navigate, useParams} from 'react-router-dom';
import React, {useEffect, useRef, useState} from 'react';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {RadioButton} from "primereact/radiobutton";
import {Fieldset} from 'primereact/fieldset';
import {InputText} from "primereact/inputtext";
import {FormatDisplay, useDataTableBasic, useForm} from '@iamsoftware/react-hooks';
import {ProductService} from '../../danh-muc/san-pham/ProductService';
import {AppStorage} from '../../../service/UserStorage';
import {getDocument} from 'pdfjs-dist';
import Draggable from 'react-draggable';

export const AgreementDetail = () => {
  let {id} = useParams();
  const [data, setData] = useState(null)
  const [agreementFileName, setAgreementFileName] = useState('');
  const [useTemplateAgreement, setUseTemplateAgreement] = useState('N');
  const [agreementNo, setAgreementNo] = useState('');
  const [products, setProducts] = useState([]);
  const [agreementContentId, setAgreementContentId] = useState('');
  const [displayFile, setDisplayFile] = useState(null);
  const [inputFile, setInputFile] = useState(null)
  const [agreementSignatureParties, setAgreementSignatureParties] = useState([]);
  const [useTemplate, setUseTemplate] = useState(false)

  const [agreementParties, setAgreementParties] = useState([{
    partyId: '',
    taxCode: '',
    partyName: '',
    emailAddress: '',
    contactNumber: '',
    representativeName: '',
    identityCard: '',
    roleTypeId: ''
  }])
  const agreementId = id
  useEffect(() => {
    Service.get(agreementId).then(res => {
      setAgreementNo(res?.agreementNo)
      if (res?.agreementDate) {
        res.agreementDate = FormatDisplay.date(new Date(res.agreementDate), 'YYYY-MM-DD');
      }
      if (res?.productId) {
        ProductService.get(res.productId).then(data => {
          res.product = {...data, value: data.productId, label: `[${data.pseudoId}] - ${data.productName}`};
          productInfoForm.setValue(res)

        })
      }
      if (res?.useTemplateAgreement === 'N') {
        setUseTemplateAgreement('N')
        setInputFile(res?.agreementContentId)
      } else if (res?.useTemplateAgreement === 'Y') {
        setUseTemplateAgreement('Y')
        setInputFile({
          "templateAgreementId": commonInfo.templateAgreementId,
          "dbFormFields": []
        })
      }
      setAgreementParties(res.agreementParties)
      setAgreementFileName(res.agreementFileName)
      setAgreementContentId(res?.agreementContentId)
      setData(res)
      commonInfoForm.setValue(res)

    })
  }, [agreementId])

  const searchProducts = event => {
    ProductService.find(event.query).then(data => {
      setProducts(data.listData.map(item => {
        delete item.disabled;
        let label = `[${item.pseudoId}]- ${item.productName}`;
        return {...item, value: item.productId, label: label}
      }))
    })
  }
  const commonInfoForm = useForm({
    fields: [
      {
        className: 'md:col-3  xxx', type: 'custom',
        body: <div>
          <div>
            <div>
              File hợp đồng<span style={{color: 'red'}}>*</span>
            </div>
            <div className='p-inputgroup mt-2'>
              <InputText value={agreementFileName} disabled/>
              <span className="p-inputgroup-addon" style={{background: '#22C55E', color: 'white', cursor: 'pointer'}} onClick={() => displayAgreementFile()}>
            <i className="pi pi-eye"/>
          </span>
            </div>
          </div>
        </div>
        , displayDependency(): boolean {
          return (useTemplateAgreement === 'N')
        },
      },
      {
        className: 'md:col-3  xxx', type: 'custom',
        body: <div>
          <div>
            <div>
              Mẫu hợp đồng<span style={{color: 'red'}}>*</span>
            </div>
            <div className='p-inputgroup mt-2'>
              <InputText value={agreementFileName} disabled/>
              <span className="p-inputgroup-addon" style={{background: '#22C55E', color: 'white', cursor: 'pointer'}} onClick={() => displayAgreementFile()}>
            <i className="pi pi-eye"/>
          </span>
            </div>
          </div>
        </div>
        , displayDependency(): boolean {
          return (useTemplateAgreement === 'Y')
        },
      },
      {
        type: 'custom', body:
          <div className="flex flex-wrap gap-3" style={{marginTop: '25px'}}>
            <div className="flex align-items-center ">
              <RadioButton size={1} inputId="option1" value="Y" onChange={(e) => setUseTemplateAgreement(e.value)} checked={useTemplateAgreement === 'Y'} disabled/>
              <label htmlFor="option1" className="ml-2">Sử dụng mẫu</label>
            </div>
            <div className="flex align-items-center">
              <RadioButton inputId="option2" value="N" onChange={(e) => setUseTemplateAgreement(e.value)} checked={useTemplateAgreement === 'N'} disabled/>
              <label htmlFor="option2" className="ml-2">Không sử dụng</label>
            </div>
          </div>, className: 'md:col-3 xxx'
      },
      {
        field: 'agreementDate', header: 'Ngày hợp đồng', InputTextProps: {type: 'date'}, className: 'md:col-2 xxx'
      },
      {
        className: 'md:col-4  xxx ', type: 'custom',
        body: <div>
          <div>
            <div>
              Số hợp đồng<span style={{color: 'red'}}>*</span>
            </div>
            <div className='p-inputgroup mt-2'>
              <InputText value={agreementNo} onChange={(e) => {
                setAgreementNo(e.target.value)
              }} disabled/>
            </div>
          </div>
        </div>
      },
      {
        field: 'agreementTaxTotal', header: 'Tiền thuế', type: 'InputNumber', className: 'md:col-2 xxx'
      },
      {
        field: 'agreementSubTotal', header: 'Tổng tiền trước thuế', type: 'InputNumber', className: 'md:col-2 xxx'
      },
      {
        field: 'agreementTotal', header: 'Giá trị hợp đồng', type: 'InputNumber', className: 'md:col-2 xxx'
      },
      {
        field: 'amountInWords', header: 'Số tiền bằng chữ', className: 'md:col-3 xxx'
      },
      {
        field: 'description', header: 'Ghi chú', className: 'md:col-3 xxx'
      },

    ], disabled: true
  });

  const productInfoForm = useForm({
    fields: [
      {
        field: 'product', header: 'Sản phẩm/Dịch vụ', type: 'AutoComplete',
        AutoCompleteProps: {suggestions: products, completeMethod: searchProducts, field: 'label', dropdown: true, placeholder: 'Tìm theo tên sản phẩm'}, className: 'md:col-6 xxx'
      },
      {
        field: 'unitAmount', header: 'Đơn giá', type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-2 xxx'
      },
      {
        field: 'quantity', header: 'Số lượng', type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-2 xxx'
      },
      {
        field: 'taxPercentage', header: '% Thuế', type: 'InputNumber', disabled: true, InputNumberProps: {suffix: '%', min: 0}, className: 'md:col-2 xxx'
      },
      {
        field: 'amount', header: 'Thành tiền', type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-3 xxx'
      },
      {
        field: 'taxTotal', header: 'Tiền thuế', type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-3 xxx'
      },
      {
        field: 'amountTotal', header: 'Tổng cộng', type: 'InputNumber', InputNumberProps: {min: 0}, className: 'md:col-6 xxx'
      },
    ],
    disabled: true
  });

  const commonInfo = commonInfoForm.getRawValue();
  const displayAgreementFile = () => {
    if (agreementContentId) {
      setDisplayFile(Date.now())
    }
  }
  const reDirect = () => {
    window.location.hash = '/hop-dong/quan-ly-hop-dong';
  }
  const fileFooter = (
    <div>
      <div>
        <Button label="Đóng" icon="pi pi-times" className="p-button-outlined p-button-secondary p-button-sm" type="button" onClick={() => setDisplayFile(false)}/>
      </div>
    </div>
  );
  return (<div className="card col-12">
    <Fieldset legend="Thông tin chung">
      {commonInfoForm.render()}
    </Fieldset>
    <Fieldset className='mt-2' legend="Sản phẩm/ dịch vụ">
      {productInfoForm.render()}
    </Fieldset>
    <AgreementParties agreementParties={agreementParties}></AgreementParties>
    <Fieldset className='mt-2' legend="Nội dung hợp đồng">
      <DisplayCanvas inputFile={inputFile} agreementParties={agreementParties} useTemplate={useTemplate} agreementData={data} agreementSignatureParties={agreementSignatureParties} setAgreementSignatureParties={setAgreementSignatureParties}></DisplayCanvas>
    </Fieldset>

    <Dialog header={`File hợp đồng - ${agreementFileName}`} maximized={true} draggable={false} footer={fileFooter} visible={!!displayFile} style={{width: '80rem', height: '60rem',}} position="top" onHide={() => setDisplayFile(false)}>
      {agreementContentId &&
				<iframe src={`${Service.baseURL}/${Service.entity}/contents/${agreementContentId}/pdf?v=${Date.now()}`} title="Hợp đồng"
								style={{width: '100%', height: '100%', border: 'none'}}/>
      }
    </Dialog>
    <div className="flex flex-row-reverse"
         style={{position:'fixed', bottom:'20px', right:'20px', padding:'10px'}}>
      <Button label={'Quay về quản lý hợp đồng'} onClick={()=>reDirect()}></Button>
    </div>
  </div>)
}

const DisplayCanvas = ({inputFile, agreementData, agreementSignatureParties, setAgreementSignatureParties, agreementParties, useTemplate}) => {
  const [numPages, setNumPages] = useState(null);
  const [pageCanvases, setPageCanvases] = useState([]);
  const canvasRefs = useRef([]);
  useEffect(() => {
    if (agreementData?.agreementId && agreementSignatureParties.length === 0) {
      agreementData.agreementSignatureParties.map(item => {
        const x = item.ulx
        const y = item.uly
        const ulx = item.ulx
        const uly = item.uly
        const signatureTypeEnumId = item.signatureTypeEnumId;
        const partyId = item.partyId
        const pageHeight = item.pageHeight;
        const pageWidth = item.pageWidth;
        const dateTime = FormatDisplay.dateTime(item.lastUpdatedStamp)
        const fontSize = 12
        const pageIndex = item.pageNumber - 1
        const locationSeqId = item.locationSeqId
        const pageNumber = item.pageNumber
        const widthPx = item.widthPx
        const heightPx = item.heightPx
        let roleTypeId = ''
        let partyName = ''
        let label = ''
        agreementParties.map(agreementParty => {
          if (agreementParty.partyId === partyId) {
            roleTypeId = agreementParty.roleTypeId
            partyName = agreementParty.partyName
            label = agreementParty.label
          }
        })
        setAgreementSignatureParties((elements) => [
          ...elements,
          {id: elements.length, x, y, fontSize, locationSeqId, pageNumber, ulx, uly, label, pageIndex, dateTime, partyName, signatureTypeEnumId, pageHeight, pageWidth, partyId, widthPx, heightPx, roleTypeId},
        ]);
      })
    }
  }, [agreementData])
  useEffect(() => {
    if (inputFile && useTemplate === false) {
      if (agreementData?.agreementId) {
        const fetchPdfData = async () => {
          try {
            const response = await fetch(`${Service.baseURL}/${Service.entity}/contents/${agreementData?.agreementContentId}/pdf`, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': AppStorage.get('moquiSessionToken')
              },
            });

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();

            const arrayBuffer = await blob.arrayBuffer();

            const loadingTask = getDocument({data: arrayBuffer});

            loadingTask.promise.then((pdf) => {
              setNumPages(pdf.numPages);

              const canvasPromises = [];
              for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                canvasPromises.push(renderPage(pdf, pageNum));
              }

              Promise.all(canvasPromises).then((canvases) => {
                setPageCanvases(canvases);
              });
            }, (reason) => {
              console.error(reason);
            });
          } catch (error) {
            console.error('Error fetching PDF:', error);
          }
        };

        fetchPdfData();
      } else {
        const reader = new FileReader();

        reader.onload = function () {
          const loadingTask = getDocument({data: new Uint8Array(this.result as any)});

          loadingTask.promise.then((pdf) => {
            setNumPages(pdf.numPages);

            const canvasPromises = [];
            for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
              canvasPromises.push(renderPage(pdf, pageNum));
            }

            Promise.all(canvasPromises).then((canvases) => {
              setPageCanvases(canvases);
            });
          }, (reason) => {
            console.error(reason);
          });
        };

        reader.readAsArrayBuffer(inputFile);
      }
    } else if (useTemplate === true) {
      if (agreementData?.agreementId) {
        const fetchPdfData = async () => {
          try {
            const response = await fetch(`${Service.baseURL}/${Service.entity}/preview-by-template`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': AppStorage.get('moquiSessionToken')
              },
              body: JSON.stringify(inputFile),
            });

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();

            const arrayBuffer = await blob.arrayBuffer();

            const loadingTask = getDocument({data: arrayBuffer});

            loadingTask.promise.then((pdf) => {
              setNumPages(pdf.numPages);

              const canvasPromises = [];
              for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                canvasPromises.push(renderPage(pdf, pageNum));
              }

              Promise.all(canvasPromises).then((canvases) => {
                setPageCanvases(canvases);
              });
            }, (reason) => {
              console.error(reason);
            });
          } catch (error) {
            console.error('Error fetching PDF:', error);
          }
        };

        fetchPdfData();
      } else {
        console.log(4)
        const fetchPdfData = async () => {
          try {
            const response = await fetch(`${Service.baseURL}/${Service.entity}/preview-by-template`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': AppStorage.get('moquiSessionToken')
              },
              body: JSON.stringify(inputFile),
            });

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();

            const arrayBuffer = await blob.arrayBuffer();

            const loadingTask = getDocument({data: arrayBuffer});

            loadingTask.promise.then((pdf) => {
              setNumPages(pdf.numPages);

              const canvasPromises = [];
              for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
                canvasPromises.push(renderPage(pdf, pageNum));
              }

              Promise.all(canvasPromises).then((canvases) => {
                setPageCanvases(canvases);
              });
            }, (reason) => {
              console.error(reason);
            });
          } catch (error) {
            console.error('Error fetching PDF:', error);
          }
        };

        fetchPdfData();
      }
    }
  }, [inputFile]);

  const renderPage = (pdf, pageNum) => {
    return pdf.getPage(pageNum).then((page) => {
      const viewport = page.getViewport({scale: 1.5});
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };

      return page.render(renderContext).promise.then(() => canvas);
    });
  };


  const removeElement = (elementId) => {
    const updatedElements = agreementSignatureParties.filter(element => element.id !== elementId);
    setAgreementSignatureParties(updatedElements);
  };

  return (
    <div className={'flex align-items-center justify-content-center '} style={{backgroundColor: 'whitesmoke'}}>
      {pageCanvases.length > 0 && (
        <div className={'mt-2'}>
          {pageCanvases.map((canvas, index) => (
            <div
              key={index}
              style={{position: 'relative', marginBottom: '20px'}}
            >
              <canvas ref={ref => {
                if (ref) {
                  ref.replaceWith(canvas);
                  canvasRefs.current[index] = canvas;
                }
              }}></canvas>
            </div>
          ))}
          {numPages && <p>Tổng số trang: {numPages}</p>}</div>)}
    </div>)

}

const AgreementParties = ({agreementParties}) => {

  const {render: renderDataTableItem} = useDataTableBasic({
    tableHeader: `Đối tượng`,
    columns: [
      {field: 'taxCode', header: 'Mã số thuế', minWidth: 120},
      {field: 'partyName', header: 'Tên công ty', minWidth: 280},
      {field: 'emailAddress', header: 'Email', width: 120},
      {field: 'contactNumber', header: 'Số điện thoại', width: 120},
      {field: 'representativeName', header: 'Họ và tên', width: 150},
      {field: 'identityCard', header: 'CCCD/CMND', width: 130},
      {field: 'roleType', header: 'Vai trò', width: 100},
      {field: 'status', header: 'Trạng thái', width: 100},
    ],
    items: agreementParties,
  });
  return (
    <div className={'col-12'}>
      {renderDataTableItem()}
    </div>
  )
}
